import React, { useState } from "react";
import { Modal, Button, Table } from 'react-bootstrap';
import styles from '../../../styles/MP/LaboratorioCemPorcentoRetorno.module.scss';
import Tabela from "../../Misc/Tabela/Tabela";

const PecasIncluidas = ({ pecasIncluidas, setPecasIncluidas, togglePecasDisponiveis }) => {
    const [pecaDeletada, setPecaDeletada] = useState({});
    const [showModalDelete, setShowModalDelete] = useState(false);

    const handleShowModalDelete = (peca) => {
        setPecaDeletada(peca);
        setShowModalDelete(true);
    }

    const handleCloseModalDelete = () => {
        setPecaDeletada({});
        setShowModalDelete(false);
    }

    const handleDeletePecasIncluidas = () => {
        const updatedPecasIncluidas =  pecasIncluidas.filter(pecaIncluida => !(pecaIncluida.peca === pecaDeletada.peca && pecaIncluida.id_teste === pecaDeletada.id_teste));
        setPecasIncluidas([...updatedPecasIncluidas]);
        togglePecasDisponiveis(updatedPecasIncluidas);

        setShowModalDelete(false);
    }

    const cols = [
        {
            name: '',
            cell: row => <Button variant="outline-danger" onClick={() => handleShowModalDelete(row)}>Deletar</Button>
        },
        { name: 'PEÇA', selector: row => row.peca },
        { name: 'TESTE', selector: row => row.desc_teste },
        { name: 'ÍNDICE', selector: row => row.indice },
        { name: 'STATUS', selector: row => row.status },
        { name: 'GRAMATURA ENCONTRADA', selector: row => row.gram_enc },
        { name: 'LARGURA ENCONTRADA', selector: row => row.larg_enc },
        { name: 'OBSERVAÇÕES', selector: row => row.obs }
    ];

    return (
        <article>
            <Tabela
                data={pecasIncluidas}
                columns={cols}
                pagination={false}
                customStylesOverrider={{
                    headCells: { style: { backgroundColor: '#FFF', justifyContent: 'center', color: '#000' } },
                    cells: { style: { justifyContent: 'center' } },
                    rows: { style: { maxHeight: '40px', minHeight: '40px', overflow: 'hidden' } }
                  }}
            />

            <Modal
                show={showModalDelete}
                onHide={handleCloseModalDelete}
                backdrop="static"
                keyboard={false}
                centered
            >
                <Modal.Header>
                    <Modal.Title>Tem certeza?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <span>A análise da peça <strong>{pecaDeletada.peca}</strong> será apagada.</span>
                </Modal.Body>
                <Modal.Footer className={styles.modalFooter}>
                    <Button
                        variant="success"
                        className={styles.modalBtn}
                        onClick={() => handleDeletePecasIncluidas()}
                    >
                        Sim
                    </Button>
                    <Button
                        variant="outline-danger"
                        className={styles.modalBtn}
                        onClick={handleCloseModalDelete}
                    >
                        Voltar
                    </Button>
                </Modal.Footer>
            </Modal>
        </article>
    );
}

export default PecasIncluidas;